import {
  Box,
  TextField,
  Button,
  Typography,
  Link,
  InputLabel,
  CircularProgress,
} from '@mui/material';
import { Formik, Form, FormikProps } from 'formik';
import '../../auth-dialog.scss';
import {
  ResetPasswordFormValues,
  resetPasswordInitialValues,
  resetPasswordSchema,
} from '../../utils/form-validation.ts';

const labelStyle = {
  color: 'white',
  fontSize: '12px',
  marginBottom: '4px',
};

interface ResetPasswordFormProps {
  setActivePage: (value: string) => void;
  userId: string | undefined;
  isPending: boolean;
  requestReset: (values: ResetPasswordFormValues) => void;
  postSubmitErrors: string;
}

export const ResetPasswordForm = ({
  setActivePage,
  userId,
  isPending,
  requestReset,
  postSubmitErrors,
}: ResetPasswordFormProps) => {
  return (
    <>
      <Typography
        sx={{ marginBottom: '12px', textAlign: 'center' }}
        data-testid="login-form"
      >
        We will send instructions to your email to reset your password.
      </Typography>
      <Formik
        initialValues={resetPasswordInitialValues}
        validationSchema={resetPasswordSchema}
        onSubmit={(values) => {
          requestReset(values);
        }}
      >
        {({
          values,
          touched,
          errors,
          handleChange,
          isValid,
        }: FormikProps<ResetPasswordFormValues>) => (
          <Form>
            <Box className="field-group">
              <Box className="field homeStylePreference">
                <InputLabel sx={labelStyle}>Email</InputLabel>
                <TextField
                  fullWidth
                  className="text-input"
                  id="username"
                  name="username"
                  placeholder="Email"
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  value={values.username}
                  error={touched.username && Boolean(errors.username)}
                />
              </Box>
            </Box>
            <Button
              disabled={isPending || !isValid}
              type="submit"
              sx={{ minWidth: '100%', position: 'relative' }}
            >
              {isPending ? <CircularProgress size={24} /> : 'Reset Password'}
            </Button>
            {!userId && (
              <>
                <Link
                  data-testid="create-account-link"
                  sx={{
                    color: 'white',
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: '12px',
                  }}
                  onClick={() => setActivePage('auth')}
                  href="#"
                  className="create-account-link"
                >
                  Don't have an account? Sign up here{' '}
                </Link>
                <Link
                  data-testid="reset-password-link"
                  sx={{
                    color: 'white',
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: '12px',
                  }}
                  onClick={() => setActivePage('login')}
                  href="#"
                  className="forgot-password-link"
                >
                  Back to sign in{' '}
                </Link>
              </>
            )}
            {postSubmitErrors && (
              <Box sx={{ marginTop: '12px' }}>
                <Typography sx={{ borderBottom: 'solid 1px white' }}>
                  Something's wrong:{' '}
                </Typography>
                <ul>
                  <li>{postSubmitErrors}</li>
                </ul>
              </Box>
            )}
          </Form>
        )}
      </Formik>
    </>
  );
};
